// Current Hierarchy: Country -> State -> City -> Building
export enum Level {
  Country = 'country',
  State = 'state',
  City = 'city',
  Building = 'building',
}

export const levels = {
  [Level.Country]: {
    value: Level.Country,
    key: 'country',
    label: 'Country',
  },

  [Level.State]: {
    value: Level.State,
    key: 'state',
    label: 'State',
  },
  [Level.City]: {
    value: Level.City,
    key: 'city',
    label: 'City',
  },
  [Level.Building]: {
    value: Level.Building,
    key: 'building',
    label: 'Building',
  },
};

export const levelsList = Object.values(levels);
